<script setup>
import { ref, onMounted } from 'vue';
import StarRating from '@/components/ui/StarRating.vue';
import vReveal from '@/directives/reveal';

const API_BASE = process.env.VUE_APP_API_BASE || 'http://localhost:3000/api/public';

const testimonials = ref([]);
const loading = ref(true);

const initials = (name) =>
  (name || '?').split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase();

onMounted(async () => {
  try {
    const res = await fetch(`${API_BASE}/testimonials?featured=true`);
    if (res.ok) testimonials.value = await res.json();
  } catch { /* show nothing on error — section is hidden */ }
  finally { loading.value = false; }
});
</script>

<template>
  <section class="testimonials" id="testimonials">
    <div class="wrap">
      <div class="section-head section-head--center" v-reveal>
        <span class="eyebrow">Traveller Stories</span>
        <h2>Countless first-light moments await.</h2>
      </div>

      <!-- Loading skeleton -->
      <div v-if="loading" class="tcards">
        <div v-for="n in 3" :key="n" class="tcard">
          <div class="skel skel--sm" style="width: 60%; height: 14px;"></div>
          <div class="skel" style="height: 18px; margin-top: 8px;"></div>
          <div class="skel" style="height: 18px; margin-top: 6px; width: 85%;"></div>
          <div class="skel" style="height: 18px; margin-top: 6px; width: 70%;"></div>
          <div class="tcard__who" style="margin-top: auto;">
            <div class="skel" style="width: 50px; height: 50px; border-radius: 50%; flex: none;"></div>
            <div style="flex: 1;">
              <div class="skel" style="height: 13px; width: 55%;"></div>
              <div class="skel" style="height: 11px; width: 40%; margin-top: 6px;"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Live data -->
      <div v-else-if="testimonials.length" class="tcards">
        <figure
          v-for="(t, i) in testimonials"
          :key="t.id"
          class="tcard"
          v-reveal
          :style="{ transitionDelay: i * 90 + 'ms' }"
        >
          <div class="tcard__mark">&ldquo;</div>
          <StarRating :value="t.rating" />
          <p v-if="t.title" class="tcard__title">{{ t.title }}</p>
          <blockquote class="tcard__quote" style="margin: 0;">{{ t.message }}</blockquote>
          <p v-if="t.tour" class="tcard__tour">{{ t.tour }}</p>
          <figcaption class="tcard__who">
            <div
              class="tcard__av"
              :style="t.c ? { background: t.c } : {}"
            >
              <img v-if="t.photo" :src="t.photo" :alt="t.name" class="tcard__av-img" />
              <span v-else style="color:#fff; font-family: var(--font-ui); font-weight: 700; font-size: 16px;">
                {{ t.init || initials(t.name) }}
              </span>
            </div>
            <div>
              <div class="tcard__name">{{ t.name }}</div>
              <div class="tcard__loc">{{ t.country }}</div>
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>
